// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line-segment{position:absolute;-webkit-transform-origin:0 100%;transform-origin:0 100%;height:1px;background:#000}", ""]);
// Exports
module.exports = exports;
